export default __webpack_public_path__ + "static/FullAccesstoTataStudi-db9475c76aee003006c9e076788ffff3.svg";